// extracted by mini-css-extract-plugin
export default {"root":"ListItem_root__5F0r2","info":"ListItem_info__8WFbo","selected":"ListItem_selected__iLc6G","rate":"ListItem_rate__5y5yt"};